module.exports = __webpack_public_path__ + "img/empty-icon.cf6fef11.png";